<template>
  <base-container :isLoading="loading">
    <ArtisanGrid
      :leftOption="leftOption"
      ref="grid"
      metaKey="JcResourceUpkeep"
      :treeSearch="treeSearch"
      :metaInited="metaInited"
      :showDialogBefore="showDialogBefore"
    >
    <template #status="{row,label}">
      <el-tag :type="statusMap[row.status]" effect="dark">{{label}}</el-tag>
    </template>
    <template #upkeepTime="{row}">
      <span>{{getupkeepTime(row)}}</span>
    </template>
      <template #upkeepPeriodForm="{ row }">
        <el-time-picker
          is-range
          v-model="row.periods"
          value-format="HH:mm"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          arrow-control
          :time-picker-options="{
            format: 'HH:mm',
          }"
          @change="timeChange(row)"
        >
        </el-time-picker>
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
import { getScheduleResources } from "@/api/jc/schedule";
import { buildTree } from "@/util/util";
import Config from "@/config/constant"
export default {
  data() {
    return {
      loading: false,
      leftOption: {
        width: "15%",
        label: "name",
        nodeKey: "key",
        data: [],
      },
      statusMap:{
        nenabled:"danger",
        enabled:"primary",
        finish:"success"
      }
    };
  },
  created() {
    this.loadResource();
  },
  methods: {
    metaInited(option) {
      let col = option.columns.find((c) => c.code == "upkeepPeriod");
      col.isSlot = true;
      col = option.columns.find((c) => c.code == "upkeepWeek");
      col.dicData = [
        {
          value: "1",
          label: "星期一",
        },
        {
          value: "2",
          label: "星期二",
        },
        {
          value: "3",
          label: "星期三",
        },
        {
          value: "4",
          label: "星期四",
        },
        {
          value: "5",
          label: "星期五",
        },
        {
          value: "6",
          label: "星期六",
        },
        {
          value: "7",
          label: "星期日",
        },
      ];
    },
    showDialogBefore(dialog, data) {
      data.periods = data.upkeepPeriod ? data.upkeepPeriod.split("-") : ["00:00","23:59"];
      dialog.isShow = true;
    },
    loadResource() {
      getScheduleResources().then((res) => {
        this.leftOption.data = buildTree(res.data.data, {
          idField: "key",
          parentField: "parentKey",
        });
      });
    },
    getupkeepTime(row){
      let label="";
      if(row.upkeepDate){
          label+=row.upkeepDate;
      }else{
        let week = Config.weeks.find(c=>c.weekNo==row.upkeepWeek);
        label+=week?.name
      }
      return label+" "+row.upkeepPeriod;
    },
    timeChange(row){
        row.upkeepPeriod=row.periods.join("-")
    },
    treeSearch(data, obj) {
      obj.hosId = "";
      obj.deptId = "";
      obj.upkeepResId = "";
      if (data.type == "hos") {
        obj.hosId = data.id;
      } else if (data.type == "dept") {
        obj.deptId = data.id;
      } else {
        obj.upkeepResId = data.id;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
